import billingApi from '@/lib/billingApi'
import type { ManagedBackup, BackupOperation } from '@/lib/api'

export type BackupDisposition = { backup_action: 'keep' | 'delete'; confirm_locked: boolean }
export type OwnerDeleteDisposition = { backup_action: 'delete'; confirm_locked: false }
export type BackupCancellationSummary = {
  count: number; bytes: number; protected_count: number
  estimated_monthly_cost: number | null
  price: { currency: string; unit_rate: number } | null
  locations: { adapter: string; state: string; count: number }[]
}
export type BackupVaultPage = {
  backups: ManagedBackup[]; page: number; per_page: number; total: number; bytes: number
  operations: BackupOperation[]
  dispositions?: { operation_id: string; server_uuid: string; action: 'keep' | 'delete'; phase: string; state: string; error_message?: string | null }[]
  price: { currency: string; unit_rate: number } | null
}
const base = '/hoard-api/account/backups'
export const backupVaultApi = {
  async list(page = 1): Promise<BackupVaultPage> {
    return (await billingApi.get<{ data: BackupVaultPage }>(base, { params: { page } })).data.data
  },
  async download(id: string): Promise<string> {
    return (await billingApi.post<{ data: { url: string } }>(`${base}/${id}/download`)).data.data.url
  },
  async protect(id: string, is_locked: boolean): Promise<void> {
    await billingApi.put(`${base}/${id}/protection`, { is_locked })
  },
  async remove(id: string, confirm_locked: boolean): Promise<BackupOperation> {
    return (await billingApi.delete<{ data: BackupOperation }>(`${base}/${id}`, { data: { confirm_locked } })).data.data
  },
  async restore(id: string, target_server_uuid: string): Promise<BackupOperation> {
    return (await billingApi.post<{ data: BackupOperation }>(`${base}/${id}/restore`, { target_server_uuid })).data.data
  },
  async cancellationSummary(server: string): Promise<BackupCancellationSummary> {
    return (await billingApi.get<{ data: BackupCancellationSummary }>(`/hoard-api/subscription/cancel/${server}/summary`)).data.data
  },
}
